// src/components/debug/DebugPanel.tsx
import React, { useState } from 'react';
import { debugAuthState, setTestAuthState } from '../../services/authDebugUtils';

interface DebugPanelProps {
  initialDebugInfo?: any;
}

const DebugPanel: React.FC<DebugPanelProps> = ({ initialDebugInfo }) => {
  const [debugInfo, setDebugInfo] = useState<any>(initialDebugInfo || null);
  const [isExpanded, setIsExpanded] = useState<boolean>(false);

  const refreshDebugInfo = () => {
    const info = debugAuthState();
    setDebugInfo(info);
  };

  const setupTestAuth = () => {
    setTestAuthState();
  };

  const clearAuth = () => {
    localStorage.removeItem('destiny_auth');
    console.log('Auth state cleared from localStorage');
    refreshDebugInfo();
    
    // Trigger the auth-state-changed event to notify components
    window.dispatchEvent(new Event('auth-state-changed'));
  };
  
  // Helper to view test character details directly
  const viewTestCharacter = (index: number) => {
    const characterIds = ['1234567890', '2345678901', '3456789012'];
    if (index >= 0 && index < characterIds.length) {
      window.location.href = `/characters/${characterIds[index]}`;
    }
  };

  // Only show in development
  if (process.env.NODE_ENV !== 'development') {
    return null;
  }

  return (
    <div className="mt-8 border border-gray-700 rounded-lg overflow-hidden">
      <div 
        className="bg-gray-800 p-3 flex justify-between items-center cursor-pointer"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <h3 className="text-destiny-gold text-sm font-medium">Development Debug Panel</h3>
        <button className="text-gray-400 hover:text-white">
          {isExpanded ? '▲ Hide' : '▼ Show'}
        </button>
      </div>

      {isExpanded && (
        <div className="p-4 bg-gray-900 text-left">
          <div className="flex flex-wrap gap-2 mb-4">
            <button
              onClick={refreshDebugInfo}
              className="bg-gray-700 text-white px-3 py-1 rounded text-sm"
            >
              Refresh Debug Info
            </button>
            <button
              onClick={setupTestAuth}
              className="bg-destiny-blue text-white px-3 py-1 rounded text-sm"
            >
              Set Test Auth State
            </button>
            <button
              onClick={clearAuth}
              className="bg-destiny-red text-white px-3 py-1 rounded text-sm"
            >
              Clear Auth State
            </button>
          </div>
          
          <div className="mb-4">
            <h4 className="text-white text-xs mb-2">Test Character Details:</h4>
            <div className="flex flex-wrap gap-2">
              <button
                onClick={() => viewTestCharacter(0)}
                className="bg-destiny-blue bg-opacity-70 text-white px-3 py-1 rounded text-sm"
              >
                View Titan
              </button>
              <button
                onClick={() => viewTestCharacter(1)}
                className="bg-destiny-blue bg-opacity-70 text-white px-3 py-1 rounded text-sm"
              >
                View Hunter
              </button>
              <button
                onClick={() => viewTestCharacter(2)}
                className="bg-destiny-blue bg-opacity-70 text-white px-3 py-1 rounded text-sm"
              >
                View Warlock
              </button>
            </div>
          </div>

          {debugInfo && (
            <div>
              <h4 className="text-white text-xs mb-2">Auth Debug Info:</h4>
              <pre className="bg-gray-800 p-3 rounded text-xs text-gray-300 overflow-auto max-h-96">
                {JSON.stringify(debugInfo, null, 2)}
              </pre>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default DebugPanel;